/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	leadGatePaymentOnDS: false
};

const leadGateSlice = createSlice({
	name: 'udsLeadGate',
	initialState,
	reducers: {
		setUdsLeadGate(state, action) {
			state.leadGatePaymentOnDS = action.payload;
		}
	}
});

export const { setUdsLeadGate } = leadGateSlice.actions;

export { initialState };

export default leadGateSlice.reducer;
